import React from 'react';

import styled from 'styled-components';

import useModelSizeLabel from '~/pdp/utils/useModelSizeLabel';
import {
  useModelImageContext,
  AttributeFieldTypes,
  useProductAttributeFieldType,
  useProductDetailContext,
} from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import parseHeight from '../../utils/parseHeight';

const Wrapper = styled.div`
  ${({ theme: { pdpStyles } }) =>
    pdpStyles.enhancedMemberModel.indicatorWrapper}
`;

export default function ModelIndicator() {
  const { activeModel } = useModelImageContext();
  const sizeCategory = useProductAttributeFieldType(AttributeFieldTypes.SIZE);
  const {
    product: { productCategoryIdList, tagIdList = [] },
  } = useProductDetailContext();
  const displaySize = useModelSizeLabel({
    model: activeModel,
    sizeCategory,
    productCategoryIdList,
    tagIdList,
  });

  if (!activeModel) {
    return null;
  }

  return (
    <Wrapper data-testid="pdp-member-model-indicator">
      <FormattedMessage
        id="site_pdp.active_member_model_indicator"
        defaultMessage="{name} - {feet}'{inches}'' Wearing Size: {size}"
        values={{
          ...parseHeight(activeModel?.heightInInches),
          name: activeModel?.firstName,
          size: displaySize,
        }}
      />
    </Wrapper>
  );
}
